export default {
	"order.TheOrderAddressModificationHasExceededTheMaximumAllowedNumberOfTimes": "该订单地址修改已超过最大允许次数",
	"order.TheOnlyChanceForTheOrderToModifyTheAddressIsLeft": "该订单修改地址的机会只剩下",
	"order.timesPleaseCheckTheInformationCarefullyBeforeSubmitting": "次，请认真核对信息后提交",
	"order.PleaseSelectAnItem": "请选择商品",
	"order.deleteFailed": "删除失败了",
	"order.AddressModifiedSuccessfully": "地址修改成功！",
	"order.orderDoesNotExist": "订单不存在",
	"order.ParameterError": "参数错误!",
	"order.TheNumberOfAddressesThatCanBeModifiedForThisOrderHasBeenExhausted": "本订单可修改地址的次数已用完",
	"order.TheFollowingIsTheDeliveryAddressForPhysicalGoods": "以下为实物商品收货地址",
	"order.hint": "提示",
	"order.understood": "知道了",
	"order.ModifiedAddressInformation": "修改后地址信息",
	"order.WhetherTheFollowingProductAddressesAreSynchronouslyModified": "以下商品地址是否同步修改",
	"order.ModifyingTheAddressOnlyChangesTheLogisticsInformationThatHasNotBeenShipped": "·修改地址仅对未发货的物流信息进行更改",
	"order.TheNumberOfChangesToTheAddressOfEachOrderMustNotExceed": "·每笔订单地址修改次数不得超过",
	"order.SecondRate": "次",
	"order.Cancel": "取消",
	"order.ConfirmTheChanges": "确认修改"
}